export default {
  XRT: "0x796FCf0421C6a03e5AA6B52D1eEEd4eFD3CD9c60",
  // AUCTION: "0x257aD558E052A0803A4a8De75E83b4e740032b97"
  AUCTION: "0x5da5C21C3AC9f6DbB83e7b1515B20cB2ACA05F76"

  // dao 0x2D2B3713F0145794d8626aABF726F113288278bA
};
